import { useLiveWireStore } from "@/stores/livewire";

function KickbacksTodayWidget() {

  const kickbackCount = useLiveWireStore(
    (state) => state.daily?.kickbacks || 0
  );

  return (
    <div className="kickbacks-today widget widget-md">
      <div className="card card-rounded">
        <div className="d-flex justify-content-between p-3">
          <div>
            <span className="bi bi-arrow-left-circle-fill text-orange me-2 fs-24"></span>
            <span className="text-black fw-bold fs-18">QA Returns Today</span>
          </div>
          <div className="px-2 py-1 fw-bold"></div>
        </div>
        <div className="card-body pt-0 text-dark d-flex justify-content-center align-items-center">
          <div className="widget-value success">{kickbackCount}</div>
        </div>
      </div>
    </div>
  );
}

export default KickbacksTodayWidget;
